import { ValidationProvider, ValidationService } from "aspnet-client-validation";

//NOTE: This must match up with the server-side implementation!

/** The word count provider name */
export const PROVIDER_NAME: string = "wordcount";

const SEGMENTER: Intl.Segmenter = new Intl.Segmenter(undefined, { granularity: "word" });

/**
 * Adds the word count provider to the validation service
 * @param validation The validation service
 */
export function addWordCountProvider(validation: ValidationService)
{
    validation.addProvider(PROVIDER_NAME, provider);
}

/**
 * A validation provider that validates word count
 */
export const provider: ValidationProvider = (value, element, params) =>
{
    if (value == null)
        return true; //Let [Required] handle empty input first

    const minWordCount: number = +params["min"];
    const maxWordCount: number = +params["max"];

    const wordCount: number = getWordCount(value);

    const minBoundValid: boolean = minWordCount === 0 || minWordCount == null || wordCount >= minWordCount;
    const maxBoundValid: boolean = maxWordCount === 0 || maxWordCount == null || wordCount <= maxWordCount;

    if (!minBoundValid)
        return `The text has too few words: Minimum: ${minWordCount.toLocaleString()}, Count: ${wordCount.toLocaleString() }`;

    if (!maxBoundValid)
        return `The text has too many words: Maximum: ${maxWordCount.toLocaleString()}, Count: ${wordCount.toLocaleString() }`;


    return true;
};

/**
 * Gets the word count of the specified text
 * @param text The text to check
 * @returns The word count
 */
export function getWordCount(text: string | null): number
{
    text ??= "";

    const segments: Intl.Segments = SEGMENTER.segment(text);

    let wordCount: number = 0;

    for (const segment of segments)
        if (segment.isWordLike)
            wordCount++;

    return wordCount;
}
